import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'

import { setActiveCustomer } from '../../actions/suites/customer'
import { setActiveRevenueCenter } from '../../actions/revenueCenter'
import { makeGetDisplaySuites } from '../../selectors/suites'
import { clearSearch } from '../../actions/search'

import {
  getHighlightedIds,
  getFocusedItemId,
  getSearchQuery,
} from '../../selectors/search'

import CustomerTabOrders from '../../components/tabs/CustomerTabOrders'

const mapStateToProps = (state, ownProps) => {
  // displaySuites is an array of objects [{ customerId: '', revenueCenterId: '', displayName: '' }]
  const getDisplaySuites = makeGetDisplaySuites()
  const displaySuites = getDisplaySuites(state)
  const highlightedIds = getHighlightedIds(state)
  const searchQuery = getSearchQuery(state)
  const focusedItemId = getFocusedItemId(state)

  return { displaySuites, focusedItemId, highlightedIds, searchQuery }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const replace = get(ownProps, 'history.replace', () => {})

  return {
    onNewOrderTapped: (customerId, revenueCenterId) => {
      dispatch(setActiveCustomer(customerId))
      dispatch(setActiveRevenueCenter(revenueCenterId))
      dispatch(clearSearch())
      replace('/tab-order')
    },
    onSettingsTapped: (customerId, revenueCenterId) => {
      replace(`/tabs/${customerId}/settings/${revenueCenterId}`)
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerTabOrders))
